// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-content-container {
    padding: 20px;
  }
  
  .button-group button {
    margin-right: 10px;
    padding: 10px;
    background-color: #2895eb;
    color:white;
    border:none;
    border-radius: 5px;
    cursor:pointer;
  }
  
  .calculator-display {
    margin-top: 20px;
    border: 1px solid #ccc;
    padding: 15px;
  }

  .dropdown-container {
    /* display: flex; */
    justify-content: center;
    margin: 20px 0;
  }

  .calculator-dropdown {
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    /* min-width: 300px; */
    width: 300px;
    background-color: white;
    cursor: pointer;
  }

  .calculator-dropdown:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0,123,255,.25);
  }
`, "",{"version":3,"sources":["webpack://./src/components/agent/agent.css"],"names":[],"mappings":"AAAA;IACI,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,yCAAyC;EAC3C","sourcesContent":[".chat-content-container {\n    padding: 20px;\n  }\n  \n  .button-group button {\n    margin-right: 10px;\n    padding: 10px;\n    background-color: #2895eb;\n    color:white;\n    border:none;\n    border-radius: 5px;\n    cursor:pointer;\n  }\n  \n  .calculator-display {\n    margin-top: 20px;\n    border: 1px solid #ccc;\n    padding: 15px;\n  }\n\n  .dropdown-container {\n    /* display: flex; */\n    justify-content: center;\n    margin: 20px 0;\n  }\n\n  .calculator-dropdown {\n    padding: 10px;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    /* min-width: 300px; */\n    width: 300px;\n    background-color: white;\n    cursor: pointer;\n  }\n\n  .calculator-dropdown:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 2px rgba(0,123,255,.25);\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
